import {
  takeLatest, put, call,
} from 'redux-saga/effects';
import api from 'store/api';
import { toast } from 'react-toastify';
import { URL } from '../../../constants/url';
import actionTypes from '../actionTypes';
import { reactivateSubscriptionAction } from '../actions';

export function* reactivateSubscription() {
  try {
    yield call(api, {
      method: 'post',
      url: URL.REACTIVATE_SUB,
    });
    yield call(toast.success, 'Subscription restored');
    yield put(reactivateSubscriptionAction.success('Subscription restored'));
    yield put({ type: 'GET_PROFILE_INFO' });
  } catch (e) {
    if (e.message.includes('No such subscription')) {
      yield call(toast.error, 'No such subscription');
      yield put(reactivateSubscriptionAction.error(e.message));
      return;
    }
    yield call(toast.error, e.message);
    yield put(reactivateSubscriptionAction.error(e.message));
  }
}

export default function* listener() {
  yield takeLatest(actionTypes.REACTIVATE_SUB, reactivateSubscription);
}
